/**
 * パスワードバリデーション（フロントエンド用）
 *
 * サーバー側にも同じバリデーションがあるが、
 * UX 向上のためフロントでも即座にチェックする。
 */

/** パスワード条件の定義 */
export interface PasswordCondition {
  label: string;
  test: (password: string, loginId?: string) => boolean;
}

/** パスワード条件一覧 */
export const PASSWORD_CONDITIONS: PasswordCondition[] = [
  { label: "10文字以上", test: (p) => p.length >= 10 },
  { label: "半角 英大文字(A-Z)を含む", test: (p) => /[A-Z]/.test(p) },
  { label: "半角 英小文字(a-z)を含む", test: (p) => /[a-z]/.test(p) },
  { label: "数字(0-9)を含む", test: (p) => /[0-9]/.test(p) },
  { label: "記号(!@#$%など)を含む", test: (p) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(p) },
  { label: "ログインIDと異なる", test: (p, loginId) => !loginId || p !== loginId },
];

/** パスワードポリシーの表示テキスト */
export const PASSWORD_RULES = "10文字以上、英大文字・英小文字・数字・記号をそれぞれ1文字以上含む、ログインIDと異なる";

/**
 * パスワードをバリデーションし、エラーメッセージを返す。
 * 有効な場合は null を返す。
 */
export function validatePassword(password: string, loginId?: string): string | null {
  const failedConditions = PASSWORD_CONDITIONS.filter((c) => !c.test(password, loginId));
  if (failedConditions.length > 0) {
    return failedConditions.map((c) => c.label).join("、") + "を満たしてください";
  }
  if (password.length > 128) {
    return "パスワードは128文字以下で入力してください";
  }
  return null;
}
